import { Col, Card, Tabs, Tab, Row } from "react-bootstrap";
import UploadRetainerOnDashboardComponent from "./UploadRetainerOnDashboardComponent";
import DocumentsFromClientComponent from "./DocumentsFromClientComponent";
import UploadDocumentsOnDashboardComponent from "./UploadDocumentsOnDashboardComponent";


const Documents = () => {
    return (
        <Row style={{width:'100%'}} className="g-0">
            <Col className="col-6">
                <Card className="document-share" style={{marginRight:'5px'}}>
                    <Card.Header>
                        <Card.Title>Share Documents With Client</Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <Tabs
                            defaultActiveKey="allDocuments"
                        >
                            <Tab eventKey="allDocuments" title="All Documents">
                                <UploadDocumentsOnDashboardComponent />
                            </Tab>
                            <Tab eventKey="retainer" title="Retainer">
                                <UploadRetainerOnDashboardComponent />
                            </Tab>
                        </Tabs>
                    </Card.Body>
                </Card>
            </Col>

            <Col className="col-6">
                <Card className="document-share" style={{marginLeft:'5px'}}>
                    <Card.Header>
                        <Card.Title>Documents from Client</Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <DocumentsFromClientComponent />
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

export default Documents;
